import { Modal, Form, Input, Select, Button } from "antd";
import { useState, useEffect } from "react";
import axios from "../../../../utils/axios";
import toast from "react-hot-toast";
import { countryList } from "../../../../helperFuncs/countryList";
import { channelController } from "../../../../controllers/channelController";

const { Option } = Select;

const AddSite = ({ closeModal, siteTypes, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const submitProjectSite = async (values) => {
    const { sitename, sitetype, country, timezone, lon, lat, finance } = values;
    const gps = `${lat},${lon}`;

    if (!/^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$/.test(gps)) {
      return toast.error("Invalid GPS format.");
    }

    setLoading(true);
    try {
      const response = await axios.post("/sitemanagement/addnewsite", {
        sitename,
        sitetype,
        gps,
        country,
        timezone,
        financing: finance,
      });

      const result = channelController(response);
      if (result.type !== "success") {
        toast.error(result.message);
        return;
      }

      toast.success("Site created successfully.");
      refresh();
      closeModal();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Create a New Project Site"
      open={true}
      onCancel={closeModal}
      footer={null}
    >
      <Form
        form={form}
        size="large"
        layout="vertical"
        onFinish={submitProjectSite}
      >
        <Form.Item
          label="Site Name"
          name="sitename"
          rules={[
            { required: true, message: "Please enter a site name" },
            {
              pattern: /^[a-zA-Z]+$/,
              message:
                "Site name must contain only letters with no spaces or special characters.",
            },
          ]}
        >
          <Input placeholder="Enter site name" />
        </Form.Item>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item
            label="Site Type"
            name="sitetype"
            rules={[{ required: true, message: "Please select a site type" }]}
          >
            <Select showSearch placeholder="Select site type">
              {siteTypes.map((type) => (
                <Option key={type} value={type}>
                  {type}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Country"
            name="country"
            rules={[{ required: true, message: "Please select a country" }]}
          >
            <Select
              placeholder="Select country"
              showSearch
              onChange={(val) => setSelectedCountry(val)}
            >
              {Object.keys(countryList).map((country) => (
                <Option key={country} value={country}>
                  {country}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        {selectedCountry && (
          <Form.Item
            label="Time Zone"
            name="timezone"
            rules={[{ required: true, message: "Please select a timezone" }]}
          >
            <Select placeholder={`Select a timezone in ${selectedCountry}`}>
              {countryList[selectedCountry]["Time Zones"].map((tz) => (
                <Option key={tz} value={tz}>
                  {tz}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        <Form.Item
          label="Finance Source"
          name="finance"
          rules={[{ required: true, message: "Please select a timezone" }]}
        >
          <Select placeholder={"Select finance source"}>
            {["UNDISCLOSED", "REA_NEP_PBG", "UEF_SSPU"].map((tz) => (
              <Option key={tz} value={tz}>
                {tz}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <div className="grid grid-cols-2 gap-4">
          <Form.Item
            label="Latitude"
            name="lat"
            rules={[{ required: true, message: "Latitude is required" }]}
          >
            <Input placeholder="Enter latitude" />
          </Form.Item>

          <Form.Item
            label="Longitude"
            name="lon"
            rules={[{ required: true, message: "Longitude is required" }]}
          >
            <Input placeholder="Enter longitude" />
          </Form.Item>
        </div>

        <Form.Item className="text-right">
          {/* <Button onClick={closeModal} style={{ marginRight: 8 }}>
            Cancel
          </Button> */}
          <Button
            type="primary"
            className="!bg-black !w-full !border-none"
            htmlType="submit"
            loading={loading}
          >
            Add Site
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddSite;
